import React from 'react'
import 'regenerator-runtime/runtime'
import {
  getAllBlogPosts,
  getBlogCategories,
  getBlogFeatureInfo,
  getFeaturedPost,
  getHomepageMetaTags
} from '../../queries/blog'
import Blog from '../../routes/Blog'
import Head from 'next/head'

const Routes = ({
  meta,
  metatags,
  data,
  categories,
  activeCategory,
  featuredPost,
  searchMode,
  featureLine
}) => {
  const currentCategory = categories?.data?.find(
    item => item.id === activeCategory
  )
  const tags = currentCategory
    ? currentCategory.attributes.meta
    : metatags.data.attributes.meta

  const twitterTags = tags?.metaSocial?.find(
    item => item.socialNetwork === 'Twitter'
  )
  const fbTags = tags?.metaSocial?.find(
    item => item.socialNetwork === 'Facebook'
  )

  return (
    <>
      <Head>
        <title>{tags.metaTitle}</title>
        <meta name="description" content={tags.metaDescription} />
        <meta name="twitter:card" content="summary" />
        <meta
          name="twitter:site"
          content={`https://www.decormatters.com/blog`}
        />
        <meta name="twitter:title" content={tags.metaTitle} />
        <meta
          name="twitter:image"
          content={
            twitterTags?.image?.data?.attributes?.url ||
            tags?.metaImage?.data?.attributes?.url
          }
        />
        <meta name="twitter:site" content="@decormattersapp" />
        <meta property="og:url" content={`https://www.decormatters.com/blog`} />
        <meta property="og:title" content={tags.metaTitle} />
        <meta property="og:description" content={tags.metaDescription} />
        <meta
          property="og:image"
          content={
            fbTags?.image?.data?.attributes?.url ||
            tags?.metaImage?.data?.attributes?.url
          }
        />
        <meta property="og:site_name" content="DecorMatters" />
      </Head>
      <Blog
        featureLine={featureLine}
        featuredPost={featuredPost.data[0]}
        categories={categories}
        pagination={meta.pagination}
        content={data}
        searchMode={searchMode}
      />
    </>
  )
}

export default Routes

export async function getStaticProps() {
  try {
    const featuredPost = await getFeaturedPost()
    const content = await getAllBlogPosts()
    const categories = await getBlogCategories()
    const metatags = await getHomepageMetaTags()
    const featureLine = await getBlogFeatureInfo()

    return {
      props: {
        ...content,
        metatags,
        featuredPost,
        featureLine,
        categories
      }
    }
  } catch (error) {
    console.log(error)

    return {
      props: {}
    }
  }
}
